/** `links` — URLs on the gig: event page, tickets, promoter deck, playlists. */
import { z } from "zod";
import { defineCollection, field } from "../define.ts";

export const links = defineCollection({
  key: "links",
  labelKey: "collections.links",
  icon: "link",
  sheetTab: "Links",
  dedupFields: ["url"],
  sort: [{ field: "label" }],
  split: "gig",
  chatHint: "URLs for the gig: event page, ticket link, promoter docs, shared playlists.",
  fields: {
    label: field({
      type: z.string().min(1),
      tier: "hot",
      pii: "promoter",
      labelKey: "links.label",
      suggestedChips: ["Event page", "Tickets", "Venue map", "Aftermovie"],
      sheet: { column: "Label" },
      description: "What the link is (event page, tickets, venue map…).",
    }),
    url: field({
      type: z.string().min(1),
      tier: "hot",
      pii: "promoter",
      labelKey: "links.url",
      sheet: { column: "URL" },
      description: "The URL.",
    }),
    notes: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "links.notes",
      sheet: { column: "Notes" },
      description: "Context for the link.",
    }),
  },
});
